// 2026-11-03 - FormuLearning - viewer(조회 전용) 역할 판정 (이슈 #114)
// 파일 위치: frontend/src/lib/readOnly.ts
// 로그인 사용자의 역할을 모듈 변수로 들고 있어 React 밖(axios 인터셉터·useDeferredSave 콜백)에서도 읽는다.
// 값은 authStore 가 로그인·checkAuth·로그아웃 때 갱신한다. 화면은 훅 `useCanWrite` 를 쓴다.
// 백엔드가 viewer 의 쓰기·실행을 403 으로 막고(`backend/app/common/deps.py` `deny_viewer_writes`),
// 화면은 그 앞에서 컨트롤을 비활성으로 보이고 요청 자체를 보내지 않는다.

export const ROLE_VIEWER = 'viewer'
/** 비활성 컨트롤의 툴팁·안내 문구(이슈 #114 «조회 전용 계정»). */
export const READ_ONLY_TITLE = '조회 전용 계정'

let readOnly = false

export function setReadOnlyRole(role: string | null | undefined): void {
  readOnly = role === ROLE_VIEWER
}

export function isReadOnly(): boolean {
  return readOnly
}

/** 인터셉터가 막은 요청의 오류 — 호출부가 «실패» 안내를 띄우지 않도록 구분한다. */
export class ReadOnlyError extends Error {
  readonly readOnly = true
  constructor() {
    super(READ_ONLY_TITLE)
    this.name = 'ReadOnlyError'
  }
}

export function isReadOnlyError(e: unknown): boolean {
  return e instanceof ReadOnlyError
}

// viewer 가 보낼 수 있는 비GET — 조작 기록(텔레메트리)·인증.
const VIEWER_WRITE_ALLOWED = /^\/?(operations|auth)(\/|$|\?)/
// viewer 가 보낼 수 없는 GET — 외부 조회를 실행한다(백엔드 `require_writer`).
const VIEWER_GET_BLOCKED = /^\/?step1\/[^/]+\/rld\/count/

/** viewer 가 이 요청을 보내면 안 되는가(baseURL `/api/v1` 기준 상대 경로). */
export function blockedForViewer(method: string | undefined, url: string | undefined): boolean {
  if (!readOnly) return false
  const m = (method ?? 'get').toLowerCase()
  const u = url ?? ''
  if (m === 'get' || m === 'head') return VIEWER_GET_BLOCKED.test(u)
  return !VIEWER_WRITE_ALLOWED.test(u)
}
